<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M4.50004 7.16659H1.83337V13.4999H4.50004M4.50004 13.4999V7.33325L7.33337 1.83325H7.74379C8.56206 1.83325 9.18726 2.56349 9.06121 3.37199L8.67746 5.83325H12.1727C13.3971 5.83325 14.3341 6.92362 14.1499 8.13414L13.5919 11.8008C13.4432 12.7779 12.6031 13.4999 11.6147 13.4999H4.50004Z"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>
